import React from 'react';
import Icon from '../../../components/AppIcon';

const RoleSelectionCard = ({ role, title, description, requirements, isSelected, onSelect }) => {
  return (
    <button
      onClick={() => onSelect(role)}
      className={`w-full p-6 md:p-8 rounded-2xl border-2 transition-all duration-250 text-left ${
        isSelected
          ? 'border-[#0025cc] bg-[#0025cc]/5'
          : 'border-[#E5E7EB] bg-white hover:border-[#0025cc]/30'
      }`}
      aria-pressed={isSelected}
    >
      <div className="flex items-start gap-4">
        <div
          className={`w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center flex-shrink-0 ${
            isSelected ? 'bg-[#0025cc]' : 'bg-[#F6F7FB]'
          }`}
        >
          <Icon
            name={role === 'candidate' ? 'User' : 'Building2'}
            size={24}
            color={isSelected ? '#FFFFFF' : '#6B7280'}
          />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg md:text-xl font-semibold text-[#111827] mb-2">
            {title}
          </h3>
          <p className="text-sm md:text-base text-[#6B7280] mb-4">
            {description}
          </p>
          <div className="space-y-2">
            {requirements?.map((req, index) => (
              <div key={index} className="flex items-start gap-2">
                <Icon
                  name="Check"
                  size={16}
                  color={isSelected ? '#0025cc' : '#6B7280'}
                  className="mt-0.5 flex-shrink-0"
                />
                <span className="text-xs md:text-sm text-[#6B7280]">{req}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </button>
  );
};

export default RoleSelectionCard;